import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";
import * as url from "../../utils/urls";
import { apiReq } from "../../utils/utils";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Loading from "../../components/Common/Loading";

function CreateJob(props) {
  const [categories, setCategories] = useState([]);
  const [content, setContent] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm();
  const history = useHistory();
  const user = useSelector((state) => state.User);
  useEffect(() => {
    if (user?.user?.role?.title !== "Admin") {
      props.history.push("/dashboard");
    }
  }, []);

  // Todo: get settings
  const getCategories = () => {
    setIsLoading(true);
    apiReq(url.GET_JOB_CATEGORY, {}, "get", null)
      .then((res) => {
        if (res.success && res.data !== null) {
          setCategories(res.data);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err>>>", err);
      });
  };

  useEffect(() => {
    getCategories();
  }, []);

  // Todo: onSubmit
  const onSubmit = (data) => {
    setIsLoading(true);
    apiReq(
      url.CREATE_JOB,
      {
        title: data.title,
        description: content,
        category: data.category,
        location: data.location,
      },
      "post",
      {
        Authorization: `Bearer ${user.user?.token}`,
      }
    )
      .then((res) => {
        if (res.success && res.data !== null) {
          history.push("/jobs");
          Swal.fire({
            title: "Success",
            text: res.message,
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err>>>", err);
      });
  };

  return (
    <React.Fragment>
      <div className="page-content">
        {isLoading && <Loading />}
        <Container fluid>
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">Create New Job</h5>
              <hr />
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="mb-3">
                  <label>Title</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter title"
                    {...register("title", { required: true })}
                  />
                  {errors.title && (
                    <span className="text-danger">Title is required</span>
                  )}
                </div>
                <div className="mb-3">
                  <label>Category</label>
                  <select
                    className="form-control"
                    {...register("category", { required: true })}
                  >
                    <option value="">Select Category</option>
                    {categories.map((category) => (
                      <option key={category.id} value={category._id}>
                        {category.title}
                      </option>
                    ))}
                  </select>
                  {errors.category && (
                    <span className="text-danger">Category is required</span>
                  )}
                </div>
                <div className="mb-3">
                  <label>Location</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter location"
                    {...register("location", { required: true })}
                  />
                  {errors.location && (
                    <span className="text-danger">Location is required</span>
                  )}
                </div>

                <div className="mb-3 privacy_editor">
                  <label>Job Description</label>
                  <CKEditor
                    editor={ClassicEditor}
                    data={content}
                    style={{ minHeight: "130px" }}
                    onReady={(editor) => {
                      // You can store the "editor" and use when it is needed.
                      console.log("Editor is ready to use!", editor);
                    }}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      setContent(data);
                      // console.log({ event, editor, data });
                    }}
                    onBlur={(event, editor) => {
                      console.log("Blur.", editor);
                    }}
                    onFocus={(event, editor) => {
                      console.log("Focus.", editor);
                    }}
                  />
                </div>

                <div>
                  <button type="submit" className="btn btn-primary">
                    Create
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default CreateJob;
